/* eslint-disable eag/match-named-export */
export const dashboardRoutes = {
  home: '/',
} as const;

export const recordAuditRoutes = {
  overview: '/record-audits',
  create: '/record-audits/new',
  detail: '/record-audits/:id',
} as const;

export const loginRoutes = {
  /**
   * @deprecated Use redirectToLogin.ts instead
   */
  login: '/login',
  loginWorkspace: `/login/workspace`,
  loginChangePassword: `/login/change-password`,
  loginForgotPassword: `/login/forgot-password`,
} as const;

export const quickPurchaseRoutes = {
  auctionsList: '/quick-purchase/auctions',
} as const;

export const employeeRoutes = {
  overview: '/employees',
  createEmployee: '/employees/create-employee',
  detail: '/employees/:id',
  personalInfo: '/employees/:id/personalInfo',
  organizationalPlacement: '/employees/:id/organizationalPlacement',
  userDataAndRole: '/employees/:id/userDataAndRole',
  externalApiKeys: '/employees/:id/externalApiKeys',
  externalSystems: '/employees/:id/externalSystems',
  externalAuthorizationSystems: '/employees/:id/externalAuthorizationSystems',
  activityLogs: '/employees/:id/activityLogs',
  employeeDetailRowControl: '/employees/:id/*',
} as const;

export const rentalOrderRoutes = {
  overview: '/rental-orders',
  overviewKanban: '/rental-orders-kanban',
  overviewCalendar: '/rental-orders-calendar',
  rowControlDetail: '/rental-order/:id/*',
  vehicleAndCustomer: '/rental-order/:id/vehicleAndCustomer',
  rentVehicle: '/rental-order/:id/rentVehicle',
  returnVehicle: '/rental-order/:id/returnVehicle',
  create: '/rental-order/create',
  detail: '/rental-order/:id',
  documents: '/rental-order/:id/documents',
  activityLogs: '/rental-order/:id/activity-logs',
  photos: '/rental-order/:id/photos',
  serviceOrder: '/rental-order/:id/service-order',
  rentVehicleInspections: '/rental-order/:id/rentVehicleInspections',
  returnVehicleInspections: '/rental-order/:id/returnVehicleInspections',
  emailActivityLogs: '/rental-order/:id/email-activity-logs',
} as const;

export const accountingRoutes = {
  invoiceOverview: '/accounting/invoices',
  cashReceiptsOverview: '/accounting/cash-receipts',
  invoiceNew: '/accounting/invoice/new',
  newCorrectiveTaxDocument: '/accounting/invoice/correctiveTaxDocument/new/:id',
  invoiceDraft: '/accounting/invoice/draft/:id',
  invoiceDetail: '/accounting/invoice/:id',
  balanceInvoiceDetail: '/accounting/invoice/balance-invoice/:id',
  correctiveTaxDocumentDetail: '/accounting/invoice/correctiveTaxDocument/:id',
  taxDocumentForPaymentDetail: '/accounting/invoice/taxDocumentForPayment/:id',
  proformaInvoiceDetail: '/accounting/invoice/proformaInvoice/:id',
  cashReceiptNestedRoute: '/accounting/cash-receipt/:id/:type',
  cashReceiptDetail: '/accounting/cash-receipt/:id',
  createCashReceiptExpense: '/accounting/cash-receipt/new/expense',
  createCashReceiptIncome: '/accounting/cash-receipt/new/income',
  newCorrectiveTaxDocumentForAftersales:
    '/accounting/invoice/correctiveTaxDocumentAftersales/:checkoutId/:paymentId',
} as const;

export const vehiclesRoutes = {
  additionalInformation: '/vehicles/:id/additional-information',
  home: '/vehicles',
  externalVehicleRedirect: '/external-vehicle/:externalVehicleId/*',
  create: '/vehicles/create',
  createRentalVehicle: '/rental-vehicles/create',
  createRentalVehicleV2: '/rental-vehicles/v2/create/:tab',
  editRentalVehicleV2: '/rental-vehicles/v2/edit/:id',
  editRentalVehicle: '/rental-vehicles/:id/edit',
  createRentalVehicleFromExistingVehicle: '/rental-vehicles/:id/create-rental-vehicle-process',
  createRentalVehicleFromExistingVehicleV2:
    '/rental-vehicles/v2/:id/create-rental-vehicle-process/:tab',
  createServiceVehicle: '/vehicles/create-service-vehicle',
  createServiceVehicleV2: '/vehicles/service-vehicle/v2/create',
  createServiceVehicleV2Tab: '/vehicles/service-vehicle/v2/create/:tab',
  createServiceFromSaleVehicleV2: '/vehicles/:id/create-service-from-sale-vehicle/v2',
  createServiceFromSaleVehicleV2Tab: '/vehicles/:id/create-service-from-sale-vehicle/v2/:tab',
  createSaleVehicleFromExistingVehicleV2: '/vehicles/:id/create-sale-vehicle-from-existing/v2/:tab',
  createServiceVehicleFromSale: '/vehicles/:id/create-service-vehicle-from-sale',
  clone: '/vehicles/clone',
  cloneV2: '/vehicles/:id/clone/v2',
  cloneV2Tab: '/vehicles/:id/clone/v2/:tab',
  cloneServiceVehicle: '/vehicles/:id/clone-service-vehicle',
  cloneServiceVehicleV2: '/vehicles/:id/clone-service-vehicle/v2',
  cloneServiceVehicleTabV2: '/vehicles/:id/clone-service-vehicle/v2/:tab',
  rentalVehicleOverview: '/vehicles/rental-vehicles',
  rowControlDetail: '/vehicles/:id/:section/*',
  detail: '/vehicles/:id/details',
  businessCases: '/vehicles/:id/business-cases',
  complaints: '/vehicles/:id/complaints',
  edit: '/vehicles/:id/edit',
  editV2: '/vehicles/:id/edit/v2',
  editV2Tab: '/vehicles/:id/edit/v2/:tab',
  createV2: '/vehicles/create/v2',
  createV2Tab: '/vehicles/create/v2/:tab',
  editServiceVehicle: '/vehicles/:id/edit-service-vehicle',
  editServiceIntervals: '/vehicles/:id/edit-service-intervals',
  vehicleData: '/vehicles/:id/vehicle-data',
  publishing: '/vehicles/:id/publishing',
  photos: '/vehicles/:id/photos/:tab',
  photoByInspectionId: '/vehicles/:id/photos/:tab/:inspectionId',
  features: '/vehicles/:id/features',
  rental: '/vehicles/:id/rental',
  serviceIntervals: '/vehicles/:id/service-intervals',
  editDetailTab: '/vehicles/:id/edit/:tab',
  conditionsInspections: '/vehicles/:id/conditions/inspections',
  inspectionDetail: '/vehicles/:id/conditions/inspections/:inspectionId',
  inspectionDetailTab: '/vehicles/:id/conditions/inspections/:inspectionId/:inspectionTab',
  conditions: '/vehicles/:id/conditions',
  conditionDetail: '/vehicles/:id/conditions/condition',
  conditionDetailTab: '/vehicles/:id/conditions/condition/:conditionTab',
  finances: '/vehicles/:id/finances',
  financesPrices: '/vehicles/:id/finances/prices',
  financesRentalPrices: '/vehicles/:id/finances/rental-prices',
  financesEarningsCosts: '/vehicles/:id/finances/earnings-costs',
  vehicleWarehouseInfo: '/vehicles/:id/warehouse-info',
  interests: '/vehicles/:id/interests',
  customers: '/vehicles/:id/customers',
  documents: '/vehicles/:id/documents',
  insights: '/vehicles/:id/insights',
  reservations: '/vehicles/:id/reservations',
  testDrives: '/vehicles/:id/test-drives',
  ownership: '/vehicles/:id/ownership',
  activeServiceCases: '/vehicles/:id/active-service-cases',
  historyOfRepairs: '/vehicles/:id/history-of-repairs',
  postponedJobs: '/vehicles/:id/postponed-jobs',
  DownloadEventVehiclePhotos: 'vehicle-photos',
  DownloadEventCondition: 'condition',
  DownloadEventInspections: 'inspections',
  DownloadEventServiceCase: 'service-case',
  DownloadEventDocuments: 'documents',
  inAdvertisement: '/vehicles/in-advertisement',
  vehicleOverview: '/vehicles',
  vehicleOpenSearch: '/vehicles/vehicle-opensearch',
  saleVehicleOpenSearch: '/vehicles/sale-vehicle-opensearch',
  serviceVehicleOpenSearch: '/vehicles/service-vehicle-opensearch',
  vehicleWarehouses: '/vehicles/warehouses',
  warehouseMovements: '/vehicles/warehouseMovements',
  threeHundredAndSixtyPhotos: '/vehicles/:id/360photos',
  activityLog: '/vehicles/:id/activity-log',
  emailActivityLogs: '/vehicles/:id/email-activity-logs',
  serviceCampaigns: '/vehicles/:id/service-campaigns',
  tires: '/vehicles/:id/tires',
  checklists: '/vehicles/:id/checklists',
  tasks: '/vehicles/:id/tasks',
  // TODO T20-120660 Audits POC — vehicle-scoped checklist audits section.
  recordAudits: '/vehicles/:id/record-audits',
} as const;

export const sourcingRoutes = {
  classifieds_comparison: '/sourcing/classifieds/comparison',
  classifieds_userToBuy: '/sourcing/classifieds/user-to-buy',
  classifieds_userHidden: '/sourcing/classifieds/user-hidden',
  classifieds_userFavourite: '/sourcing/classifieds/user-favourite',
  classifieds_userCarvagoBuy: '/sourcing/classifieds/user-carvago-buy',
  auctions_comparison: '/sourcing/auctions/comparison',
  auctions_userToBuy: '/sourcing/auctions/user-to-buy',
  auctions_userHidden: '/sourcing/auctions/user-hidden',
  auctions_userFavourite: '/sourcing/auctions/user-favourite',
  home: '/sourcing',
  classifieds: '/sourcing/classifieds',
  auctions: '/sourcing/auctions',
  vehicleDetail: '/sourcing/vehicle/:adId',
  auctionDetail: '/sourcing/auction/:adId',
} as const;

export const customerRoutes = {
  overview: '/customer',
  gdprConsentsOverview: '/customer/gdpr-consents',
  create: '/customer/create',
  detail: '/customer/:id',
  checklists: '/customer/:id/checklists',
  customerInformation: '/customer/:id/customerInformation',
  GDPRConsents: '/customer/:id/GDPRConsents',
  businessCases: '/customer/:id/businessCases',
  interests: '/customer/:id/interests',
  vehicles: '/customer/:id/vehicles',
  documents: '/customer/:id/documents',
  invoices: '/customer/:id/invoices',
  serviceCases: '/customer/:id/serviceCases',
  customerContracts: '/customer/:id/customerContracts',
  customerOrders: '/customer/:id/customerOrders',
  activityLogs: '/customer/:id/activityLogs',
  tires: '/customer/:id/tires',
  rowControlDetail: '/customer/:id/*',
  tasks: '/customer/:id/tasks',
  emailActivityLogs: '/customer/:id/email-activity-logs',
  messageHistoryVisualDebug: '/customer/:id/message-history-visual-debug',
} as const;

export const inspectionRoutes = {
  inspection: '/inspection',
} as const;

export const analyticsRoutes = {
  overview: '/analytics',
  dashboard: '/analytics/:id',
  cloudOverview: '/analytics/cloud',
  cloudDashboard: '/analytics/cloud/:id',
} as const;

export const businessCaseRoutes = {
  home: '/business-case',
  openSearch: '/business-case/open-search',
  complaintsList: '/business-case/complaints',
  concept: '/business-case/concept',
  detail: '/business-case/:id/:section',
  overview: '/business-case/:id/overview',
  checklists: '/business-case/:id/checklists',
  customer: '/business-case/:id/customer',
  buying: '/business-case/:id/buying',
  testDrive: '/business-case/:id/test-drive',
  selling: '/business-case/:id/selling',
  checkout: '/business-case/:id/checkout',
  documents: '/business-case/:id/documents',
  reservations: '/business-case/:id/reservations',
  insurance: '/business-case/:id/insurance',
  activityLog: '/business-case/:id/activity-log',
  emailActivityLogs: '/business-case/:id/email-activity-logs',
  complaints: '/business-case/:id/complaints',
  tasks: '/business-case/:id/tasks',
  serviceCases: '/business-case/:id/service-cases',
} as const;

export const opportunitiesKanbanRoutes = {
  home: '/opportunities-kanban',
} as const;

export const interestRoutes = {
  overview: '/interest',
  workshopOverview: '/interest/workshop',
  concept: '/interest/concept',
  create: '/interest/create',
  detail: '/interest/:id/:section',
  detailOverview: '/interest/:id/overview',
  detailCustomer: '/interest/:id/customer',
  detailSelling: '/interest/:id/selling',
  detailBuying: '/interest/:id/buying',
  detailChecklists: '/interest/:id/checklists',
  detailTasks: '/interest/:id/tasks',
  detailActivityLog: '/interest/:id/activity-log',
} as const;

export const addCarRoute = '/add-car';

export const myProfileRoutes = {
  home: '/my-profile',
  emailServices: '/my-profile/email-services',
  emailSynchronization: '/my-profile/email-synchronization',
  language: '/my-profile/language',
  personalInformation: '/my-profile/personal-information',
  dashboard: '/my-profile/dashboard',
  security: '/my-profile/security',
  notifications: '/my-profile/notification',
  emailSignature: '/my-profile/email-signature',
  notificationDetail: '/my-profile/notification/:id',
  externalSystems: '/my-profile/external-systems',
  multiFactorAuthentication: '/my-profile/multi-factor-authentication',
  calendarSynchronization: '/my-profile/calendar-synchronization',
  tableExports: '/my-profile/table-exports',
} as const;

export const settingsRoutes = {
  home: '/settings',
  advertising: '/settings/advertising',
  accountingCodes: '/settings/accounting-codes',
  accountingCodesDetail: '/settings/accounting-codes/:id',
  backgroundRemoval: '/settings/advertising/background-removal',
  backgroundRemovalCreate: '/settings/advertising/background-removal/create',
  backgroundRemovalDetail: '/settings/advertising/background-removal/:id',
  advertisingQuickPresets: '/settings/advertising/quick-presets',
  advertisingQuickPresetsDetail: '/settings/advertising/quick-presets/:id',
  advertisingQuickPresetsCreate: '/settings/advertising/quick-presets/create',
  advertisingPlatforms: '/settings/advertising/platforms',
  advertisingPlatformsDetail: '/settings/advertising/platforms/:code',
  advertisingPromoPhotos: '/settings/advertising/promotional-photos',
  advertisingPromoPhotosCreate: '/settings/advertising/promotional-photos/create',
  advertisingPromoPhotosDetail: '/settings/advertising/promotional-photos/:id',
  aiLeadManagement: '/settings/ai-lead-management',
  aiLeadManagementHistory: '/settings/ai-lead-history',
  digitalDeal: '/settings/digital-deal',
  advertisingWatermarking: '/settings/advertising/watermark',
  advertisingWatermarkingCreate: '/settings/advertising/watermark/create',
  advertisingWatermarkingDetail: '/settings/advertising/watermark/:id',
  salePreset: '/settings/advertising/sale-preset',
  salePresetCreate: '/settings/advertising/sale-preset/create',
  salePresetDetail: '/settings/advertising/sale-preset/:id',
  exportParameters: '/settings/accounting-integrations/export-parameters',
  advertisingQrCodeDefinition: '/settings/advertising/qr-code',
  notificationsOverview: '/settings/notification',
  notificationsDetail: '/settings/notification/:id',
  businessCase: '/settings/business-case',
  businessCaseDueDates: '/settings/business-case/due-dates',
  businessCaseDueDatesDetail: '/settings/business-case/due-dates/:id',
  businessCaseDueDatesNew: '/settings/business-case/due-dates/new',
  businessCaseDefinition: '/settings/business-case/business-case-definition',
  businessCaseCentralizedPricing: '/settings/business-case/centralized-pricing',
  businessCaseCommissionFee: '/settings/business-case/commission-fee',
  businessCaseEditCommissionFee: '/settings/business-case/commission-fee/:id',
  businessCaseCreateCommissionFee: '/settings/business-case/commission-fee/new',
  businessCaseOfferValidity: '/settings/business-case/offer-validity',
  businessCaseOfferValidityDetail: '/settings/business-case/offer-validity/:id',
  businessCaseOfferValidityNew: '/settings/business-case/offer-validity/new',
  interest: '/settings/interest',
  interestDefinition: '/settings/interest/interest-definition',
  interestDefinitionDetail: '/settings/interest/interest-definition/:id',
  salesLeadsAssignment: '/settings/interest/sales-leads-assignment',
  salesLeadsAssignmentNew: '/settings/interest/sales-leads-assignment/new',
  salesLeadsAssignmentEdit: '/settings/interest/sales-leads-assignment/:id',
  productCatalog: '/settings/product-catalog',
  codelistDetail: '/settings/codelists/:id',
  codelists: '/settings/codelists',
  customFields: '/settings/custom-fields',
  vehicleTopMakes: '/settings/top-makes',
  signatures: '/settings/signatures',
  vehicleSeriesDefinition: '/settings/vehicle-series-definition',
  vehicleNewSeriesDefinition: '/settings/vehicle-series-definition/new',
  vehicleEditSeriesDefinition: '/settings/vehicle-series-definition/:id',
  vehicleInspections: '/settings/inspections',
  vehicleInspectionDetail: '/settings/inspections/:id',
  vehicleInspectionsNew: '/settings/inspections/new',
  vehicleCondition: '/settings/condition',
  vehicleParking: '/settings/parking',
  esignoDetail: '/settings/esigno',
  vehicleParkingAdd: '/settings/parking/add',
  vehicleParkingEdit: '/settings/parking/:id',
  customerCodeDefinition: '/settings/customer-definition',
  customerCodeDefinitionDetail: '/settings/customer-definition/:id',
  bankTransferSettings: '/settings/bank-transfer-settings',
  roleManagement: '/settings/role-management',
  roleManagementDetail: '/settings/role-management/:roleId',
  serviceAccountManagement: '/settings/service-account-management',
  serviceAccountManagementCreate: '/settings/service-account-management/create',
  serviceAccountManagementDetail: '/settings/service-account-management/:serviceAccountId',
  userManagement: '/settings/user-management',
  userManagementDetailV2: '/settings/user-management/v2/:id',
  userManagementAddUserV2: '/settings/user-management/v2/add-user',
  userManagementInviteUser: '/settings/user-management/invite-user',
  teamManagement: '/settings/team-management',
  teamManagementAddTeam: '/settings/team-management/add-team',
  teamManagementDetail: '/settings/team-management/:id',
  documentTemplates: '/settings/document-templates',
  documentTemplateEditor: '/settings/document-templates/:id/edit',
  vatTotalAndCalculationOverview: '/settings/vat-total-and-calculation',
  vatTotalAndCalculationDetail: '/settings/vat-total-and-calculation/:id',
  vatTotalAndCalculationNew: '/settings/vat-total-and-calculation/new',
  warehousesList: '/settings/warehouse/warehouses',
  warehousesCreate: '/settings/warehouse/warehouses/create',
  warehousesDetail: '/settings/warehouse/warehouses/:id',
  warehousesMarketingCode: '/settings/warehouse/marketing-code',
  warehousesMarketingCodeCreate: '/settings/warehouse/marketing-code/create',
  warehousesMarketingCodeDetail: '/settings/warehouse/marketing-code/:id',
  warehousesDirectSaleVariants: '/settings/warehouse/direct-sale-variants',
  warehousesDirectSaleVariantsCreate: '/settings/warehouse/direct-sale-variants/create',
  warehousesDirectSaleVariantsDetail: '/settings/warehouse/direct-sale-variants/:id',
  warehousesArticleCategory: '/settings/warehouse/article-category',
  warehousesArticleCategoryCreate: '/settings/warehouse/article-category/create',
  warehousesArticleCategoryDetail: '/settings/warehouse/article-category/:id',
  warehousesManufacturers: '/settings/warehouse/manufacturers',
  warehousesManufacturersCreate: '/settings/warehouse/manufacturers/create',
  warehousesManufacturersDetail: '/settings/warehouse/manufacturers/:id',
  warehousesMeasurementUnits: '/settings/warehouse/measurementUnits',
  warehousesMeasurementUnitsCreate: '/settings/warehouse/measurementUnits/create',
  warehousesMeasurementUnitsDetail: '/settings/warehouse/measurementUnits/:id',
  warehousesDispensingUnitsPresets: '/settings/warehouse/dispensing-units-presets',
  warehousesDispensingUnitsPresetsCreate: '/settings/warehouse/dispensing-units-presets/create',
  warehousesDispensingUnitsPresetsDetail: '/settings/warehouse/dispensing-units-presets/:id',
  warehousesSupplierOrderVariants: '/settings/warehouse/warehouseSupplierOrderVariants',
  warehousesSupplierOrderVariantsCreate:
    '/settings/warehouse/warehouseSupplierOrderVariants/create',
  warehousesSupplierOrderVariantsDetail: '/settings/warehouse/warehouseSupplierOrderVariants/:id',
  warehousesTransferOrderVariants: '/settings/warehouse/transfer-order-variants',
  warehousesTransferOrderVariantsCreate: '/settings/warehouse/transfer-order-variants/create',
  warehousesTransferOrderVariantsDetail: '/settings/warehouse/transfer-order-variants/:id',
  warehousesSupplierDiscountGroups: '/settings/warehouse/supplier-discount-groups',
  warehousesSupplierDiscountGroupsDetail: '/settings/warehouse/supplier-discount-groups/:id',
  warehousesSpaces: '/settings/warehouse/spaces',
  warehousesSpacesCreate: '/settings/warehouse/spaces/create',
  warehousesSpacesDetail: '/settings/warehouse/spaces/:id',
  suppliers: '/settings/suppliers',
  gdprConsentTypes: '/settings/gdpr-consent-types',
  gdprConsentTypesNew: '/settings/gdpr-consent-types/new',
  gdprConsentTypesEdit: '/settings/gdpr-consent-types/:id',
  tenant: '/settings/tenant-profile',
  tenantLogos: '/settings/tenant-logos',
  holidayCalendar: '/settings/holiday-calendar',
  billingInformation: '/settings/billing-information',
  billingInformationEdit: '/settings/billing-information/:id',
  billingInformationNew: '/settings/billing-information/new',
  seriesDefinition: '/settings/series-definition',
  seriesDefinitionNew: '/settings/series-definition/new',
  seriesDefinitionEdit: '/settings/series-definition/:id',
  correctiveTaxDocuments: '/settings/corrective-tax-documents',
  correctiveTaxDocumentsNew: '/settings/corrective-tax-documents/new',
  correctiveTaxDocumentsEdit: '/settings/corrective-tax-documents/edit/:id',
  messageTemplates: '/settings/message-templates',
  messageTemplatesNew: '/settings/message-templates/new/:type',
  messageTemplatesEdit: '/settings/message-templates/edit/:id/:type',
  branches: '/settings/branches',
  branchesNew: '/settings/branches/new',
  branchesEdit: '/settings/branches/:id',
  cashRegisters: '/settings/cash-registers',
  proformaGeneration: '/settings/proforma-generation',
  proformaGenerationDetail: '/settings/proforma-generation/:id',
  proformaGenerationNew: '/settings/proforma-generation/new',
  taxDocumentIssuedType: '/settings/tax-document/issued-type',
  taxDocumentIssuedTypeDetail: '/settings/tax-document/issued-type/:id',
  taxDocumentIssuedTypeNew: '/settings/tax-document/issued-type/new',
  taxDocumentImportType: '/settings/tax-document/import-type',
  taxDocumentImportTypeDetail: '/settings/tax-document/import-type/:branchId',
  taxDocumentImportTypeNew: '/settings/tax-document/import-type/new',
  invoiceCanceling: '/settings/invoice-canceling',
  invoiceCancelingDetail: '/settings/invoice-canceling/:id',
  accountingErrorLog: '/settings/accounting-error-logs',
  accountingErrorLogDetail: '/settings/accounting-error-logs/:id',
  accountingActivityLog: '/settings/accounting-activity-logs',
  accountingMatrixManagement: '/settings/accounting-matrix-management',
  newInvoiceCanceling: '/settings/invoice-canceling/new',
  invoiceMarginOverview: '/settings/invoice-margin',
  newInvoiceMargin: '/settings/invoice-margin/new',
  invoiceMarginDetail: '/settings/invoice-margin/:id',
  invoiceCostOverview: '/settings/invoice-costs',
  accountingOperationDefaultsOverview: '/settings/accounting-operation-defaults',
  accountingOperationDefaultsDetail: '/settings/accounting-operation-defaults/:id',
  generatedDocuments: '/settings/generated-documents',
  invoiceCostNew: '/settings/invoice-costs/new',
  invoiceCostDetail: '/settings/invoice-costs/:id',
  accountingOperationAuthorizationsOverview: '/settings/accounting-operation-authorization',
  accountingOperationAuthorizationDetail: '/settings/accounting-operation-authorization/:id',
  accountingOperationAuthorizationNew: '/settings/accounting-operation-authorization/new',
  cashRegistersDetail: '/settings/cash-registers/:id',
  newCashRegister: '/settings/cash-registers/new',
  cashLimits: '/settings/cash-limits',
  cashLimitsAdd: '/settings/cash-limits/add',
  cashLimitsEdit: '/settings/cash-limits/:id',
  qrCodeSettings: '/settings/qr-code-settings',
  qrCodeSettingsAdd: '/settings/qr-code-settings/add',
  qrCodeSettingsEdit: '/settings/qr-code-settings/:id',
  invoiceDefinition: '/settings/invoice-definition',
  invoiceDefinitionEdit: '/settings/invoice-definition/:id',
  ProformaCreationOverview: '/settings/proforma-creation',
  ProformaCreationEdit: '/settings/proforma-creation/:id',
  ProformaCreationCreate: '/settings/proforma-creation/new',
  documentRoundingDefinitions: '/settings/document-rounding-definitions',
  documentRoundingDefinitionsAdd: '/settings/document-rounding-definitions/add',
  documentRoundingDefinitionsEdit: '/settings/document-rounding-definitions/:id/edit',
  preAccountingProcessingOverview: '/settings/pre-accounting-processing',
  preAccountingProcessingDetail: '/settings/pre-accounting-processing/:id',
  preAccountingProcessingNew: '/settings/pre-accounting-processing/new',
  accountingIntegrations: '/settings/accounting-integrations',
  accountingIntegrationsAbra: '/settings/accounting-integrations/abra',
  vehicleServices: '/settings/vehicle-services',
  vehicleServicesCebia: '/settings/vehicle-services/cebia',
  vehicleServicesCarpass: '/settings/vehicle-services/carpass',
  vehicleServicesCarpassDetail: '/settings/vehicle-services/carpass/:id',
  vehicleServicesFeatures: '/settings/vehicle-services/features',
  vehicleServicesRokVy: '/settings/vehicle-services/rokvy',
  vehicleWarehouseManagement: '/settings/vehicle-warehouse-management/',
  vehicleWarehouseCreate: '/settings/vehicle-warehouse-management/create',
  vehicleWarehouseEdit: '/settings/vehicle-warehouse-management/:id',
  mandatoryFields: '/settings/mandatory-fields',
  smsGateways: '/settings/sms-gateways',
  smsGatewaysKonzulta: '/settings/sms-gateways/konzulta',
  whatsApp: '/settings/whatsapp',
  facebookCredentials: '/settings/facebook-credentials',
  emailServices: '/settings/email-services',
  autostacjaSettings: '/settings/autostacja',
  autostacjaSettingsSubscriptionKey: '/settings/autostacja/subscription-key',
  jbr: '/settings/jbr',
  jbrSettings: '/settings/jbr-settings',
  customerVerificationServices: '/settings/customer-verification-services',
  customerVerificationDistraints: '/settings/customer-verification-services/distraints',
  reservation: '/settings/reservation',
  financing: '/settings/financing',
  locale: '/settings/locale',
  workshopPresetsCategory: '/settings/workshop-presets-category',
  workshopPresetsCategoryCreate: '/settings/workshop-presets-category/create',
  workshopPresetsCategoryDetail: '/settings/workshop-presets-category/:id',
  inspections: '/settings/inspectionsV2',
  inspectionCreate: '/settings/inspectionsV2/create',
  inspectionDetail: '/settings/inspectionsV2/:id',
  workType: '/settings/work-type',
  workTypeCreate: '/settings/work-type/create',
  workTypeDetail: '/settings/work-type/:id',
  vehicleGroups: '/settings/vehicle-groups',
  vehicleGroupsCreate: '/settings/vehicle-groups/create',
  vehicleGroupsDetail: '/settings/vehicle-groups/:id',
  employeeCompetences: '/settings/employee-competences',
  employeeCompetencesCreate: '/settings/employee-competences/create',
  employeeCompetencesDetail: '/settings/employee-competences/:id',
  labourRates: '/settings/labour-rates',
  labourRatesCreate: '/settings/labour-rates/create',
  labourRatesDetail: '/settings/labour-rates/:id',
  employeeCostCenters: '/settings/employee-cost-centers',
  employeeCostCentersCreate: '/settings/employee-cost-centers/create',
  employeeCostCentersDetail: '/settings/employee-cost-centers/:id',
  employeeWorkTeams: '/settings/employee-work-teams',
  employeeWorkTeamsCreate: '/settings/employee-work-teams/create',
  employeeWorkTeamsDetail: '/settings/employee-work-teams/:id',
  employeeProfessions: '/settings/employee-professions',
  employeeProfessionsCreate: '/settings/employee-professions/create',
  employeeProfessionsDetail: '/settings/employee-professions/:id',
  serviceCaseType: '/settings/service-case-type',
  serviceCaseTypeCreate: '/settings/service-case-type/create',
  serviceCaseTypeDetail: '/settings/service-case-type/:id',
  serviceOrderVariants: '/settings/service-order-variants',
  serviceOrderVariantsCreate: '/settings/service-order-variants/create',
  serviceOrderVariantsDetail: '/settings/service-order-variants/:id',
  salesServiceOrderVariants: '/settings/sales/service-order-variants',
  salesServiceOrderVariantsDetail: '/settings/sales/service-order-variants/:id',
  labourCatalogues: '/settings/labour-catalogues',
  labourCataloguesCreate: '/settings/labour-catalogues/create',
  labourCataloguesDetail: '/settings/labour-catalogues/:id',
  workshopCustomerGroups: '/settings/workshop-customer-groups',
  workshopCustomerGroupCreate: '/settings/workshop-customer-groups/create',
  workshopCustomerGroupDetail: '/settings/workshop-customer-groups/:id',
  workshopSmallUnitMaterial: '/settings/workshop-small-unit-material',
  workshopSmallUnitMaterialDetail: '/settings/workshop-small-unit-material/:id',
  workshopSmallUnitMaterialCreate: '/settings/workshop-small-unit-material/create',
  customerContracts: '/settings/customer-contracts',
  customerContractsCreate: '/settings/customer-contracts/create',
  customerContractsDetail: '/settings/customer-contracts/:id',
  tiresInventory: '/settings/tires-inventory',
  tiresInventoryCreate: '/settings/tires-inventory/create',
  tiresInventoryDetail: '/settings/tires-inventory/:id',
  tireTransit: '/settings/tire-transit',
  tireTransitCreate: '/settings/tire-transit/create',
  tireTransitDetail: '/settings/tire-transit/:id',
  tireManufacturers: '/settings/tire-manufacturers',
  tireLocations: '/settings/tire-locations',
  tireWarehouses: '/settings/tire-warehouses',
  tireWarehousesCreate: '/settings/tire-warehouses/create',
  tireWarehousesDetail: '/settings/tire-warehouses/:id',
  workshopServicePackages: '/settings/workshop-service-packages',
  workshopCreateServicePackages: '/settings/workshop-service-packages/create',
  workshopEditServicePackages: '/settings/workshop-service-packages/:id',
  workshopMeasurementUnits: '/settings/measurement-units',
  workshopMeasurementUnitCreate: '/settings/measurement-units/create',
  workshopMeasurementUnitDetail: '/settings/measurement-units/:id',
  workshopServiceOrderGroups: '/settings/service-groups',
  workshopServiceOrderGroupCreate: '/settings/service-groups/create',
  workshopServiceOrderGroupDetail: '/settings/service-groups/:id',
  workshopSelectableMaterials: '/settings/selectable-materials',
  workshopSelectableMaterialsDetail: '/settings/selectable-materials/:id',
  workshopInterest: '/settings/workshop/interest',
  workshopInterestSeriesDefinition: '/settings/workshop/interest-definition',
  workshopInterestSourceCodelist: '/settings/workshop/interest-codelist/:id',
  generalChecklist: '/settings/general-checklist',
  generalChecklistCreate: '/settings/general-checklist/create',
  generalChecklistDetail: '/settings/general-checklist/:id',
  recordAuditDefinition: '/settings/record-audit-definition',
  recordAuditDefinitionCreate: '/settings/record-audit-definition/create',
  recordAuditDefinitionDetail: '/settings/record-audit-definition/:id',
  tireWidth: '/settings/tire-width',
  tireWidthCreate: '/settings/tire-width/create',
  tireWidthDetail: '/settings/tire-width/:id',
  tireAspectRatio: '/settings/tire-aspect-ratio',
  tireAspectRatioCreate: '/settings/tire-aspect-ratio/create',
  tireAspectRatioDetail: '/settings/tire-aspect-ratio/:id',
  tireRimSize: '/settings/tire-rim-size',
  tireRimSizeCreate: '/settings/tire-rim-size/create',
  tireRimSizeDetail: '/settings/tire-rim-size/:id',
  tireLoadIndex: '/settings/tire-load-index',
  tireLoadIndexCreate: '/settings/tire-load-index/create',
  tireLoadIndexDetail: '/settings/tire-load-index/:id',
  tireSpeedRatio: '/settings/tire-speed-ratio',
  tireSpeedRatioCreate: '/settings/tire-speed-ratio/create',
  tireSpeedRatioDetail: '/settings/tire-speed-ratio/:id',
  tireCategory: '/settings/tire-category',
  tireCategoryCreate: '/settings/tire-category/create',
  tireCategoryDetail: '/settings/tire-category/:id',
  priceGroupList: '/settings/rental/price-group',
  priceGroupNew: '/settings/rental/price-group/new',
  priceGroupDetail: '/settings/rental/price-group/:id',
  workshopUnits: '/settings/workshop/dictionaries/units',
  workshopUnitCreate: '/settings/workshop/dictionaries/units/create',
  workshopUnitDetail: '/settings/workshop/dictionaries/units/:id',
  workshopVehicleClasses: '/settings/workshop/dictionaries/vehicle-classes',
  workshopVehicleClassCreate: '/settings/workshop/dictionaries/vehicle-classes/create',
  workshopVehicleClassDetail: '/settings/workshop/dictionaries/vehicle-classes/:id',
  workshopInsuranceTypes: '/settings/workshop/dictionaries/insurance-types',
  workshopInsuranceTypesCreate: '/settings/workshop/dictionaries/insurance-types/create',
  workshopInsuranceTypesDetail: '/settings/workshop/dictionaries/insurance-types/:id',
  tireCondition: '/settings/tire-condition',
  tireConditionCreate: '/settings/tire-condition/create',
  tireConditionDetail: '/settings/tire-condition/:id',
  partDepartment: '/settings/part-department',
  chatSettings: '/settings/chat',
  twoFactorSettings: '/settings/two-factor',
  editRentalCodeList: '/settings/rental/codelist/:id',
  carRentalSeries: '/settings/rental/car-rental-series',
  templateManagement: '/settings/template-management',
  scheduledMessages: '/settings/scheduled-messages',
  scheduledMessagesDetail: '/settings/scheduled-messages/:id',
} as const;

export const workshopRoutes = {
  overview: '/workshop',
  serviceCases: '/workshop/service-cases',
  serviceOrders: '/workshop/service-orders',
  serviceCasesOpenSearch: '/workshop/service-cases-open-search',
  createServiceCase: '/workshop/service-case/create',
  serviceCaseDetail: '/workshop/service-cases/:id',
  draftServiceCase: '/workshop/draft-service-case/:id',
  directSales: '/workshop/direct-sales',
  labourOperationSettings: '/workshop/labour-operation-settings',
  interest: '/workshop/interest',
  interestCreate: '/workshop/interest/create',
  interestDetail: '/workshop/interest/:id/:section',
  interestDetailOverview: '/workshop/interest/:id/overview',
  interestDetailCustomer: '/workshop/interest/:id/customer',
  interestDetailOwnership: '/workshop/interest/:id/ownership',
  interestDetailServiceRequest: '/workshop/interest/:id/service-request',
  interestDetailChecklist: '/workshop/interest/:id/checklist',
  interestDetailTasks: '/workshop/interest/:id/tasks',
  interestDetailActionLog: '/workshop/interest/:id/action-log',
  serviceCampaigns: '/workshop/service-campaigns',
  serviceCampaignDetail: '/workshop/service-campaign/:id',
  serviceCampaignsUnfinished: '/workshop/service-campaigns/unfinished',
  postponedRequests: '/workshop/postponed-requests',
  reporting: '/workshop/reporting',
  reportingTab: '/workshop/reporting/:id',
  reportingMercedesMra: '/workshop/reporting/mercedes-mra',
  reportingMercedesMraCustomReports: '/workshop/reporting/mercedes-mra-custom-reports',
  reportingMercedesMraInactiveReports: '/workshop/reporting/mercedes-mra-inactive-reports',
  reportingFiveStar: '/workshop/reporting/5star',
  reportingCStar: '/workshop/reporting/cstar',
} as const;

export const warehouseRoutes = {
  articleList: '/warehouses/article-list',
  articleDetailRowControl: '/warehouses/:warehouseId/article/:id/:section*',
  articleDetailOverview: '/warehouses/:warehouseId/article/:id/overview',
  articleDetailAvailability: '/warehouses/:warehouseId/article/:id/availability',
  articleDetailReceipts: '/warehouses/:warehouseId/article/:id/receipts',
  articleDetailMovements: '/warehouses/:warehouseId/article/:id/movements',
  articleDetailReservations: '/warehouses/:warehouseId/article/:id/reservations',
  articleDetailSupplierArticles: '/warehouses/:warehouseId/article/:id/supplierArticles',
  articleDetailUpdateJobsLog: '/warehouses/:warehouseId/article/:id/update-jobs-log',
  articleDetailDocuments: '/warehouses/:warehouseId/article/:id/documents',
  articleDetailChecklists: '/warehouses/:warehouseId/article/:id/checklists',
  serviceOrderIssueNew: '/warehouses/service-order-issue/:serviceOrderIssueNoteId/new',
  serviceOrderIssueCreate: '/warehouses/service-order-issue/create',
  serviceOrderIssues: '/warehouses/service-order-issues',
  serviceOrderIssueDetailRowControl: '/warehouses/service-order-issue/:id/:section*',
  serviceOrderIssueDetailOverview: '/warehouses/service-order-issue/:id/overview',
  serviceOrderIssueDetailIssueNotes: '/warehouses/service-order-issue/:id/issueNotes',
  serviceOrderIssueDetailDocuments: '/warehouses/service-order-issue/:id/documents',
  serviceOrderIssueDetailChecklists: '/warehouses/service-order-issue/:id/checklists',
  issueNotes: '/warehouses/issue-notes',
  issueNoteDetailRowControl: '/warehouses/issue-notes/:id/:section*',
  issueNoteDetailOverview: '/warehouses/issue-notes/:id/overview',
  issueNoteDetailIssueNoteCorrections: '/warehouses/issue-notes/:id/issue-note-corrections',
  issueNoteDetailCostCorrections: '/warehouses/issue-notes/:id/costCorrections',
  issueNoteDetailDocuments: '/warehouses/issue-notes/:id/documents',
  serviceOrderReturns: '/warehouses/service-order-returns',
  serviceOrderReturnsCreate: '/warehouses/service-order-returns/create',
  serviceOrderReturnsDetailRowControl: '/warehouses/service-order-returns/:id/:section*',
  serviceOrderReturnsDetailOverview: '/warehouses/service-order-returns/:id/overview',
  serviceOrderReturnsDetailDocuments: '/warehouses/service-order-returns/:id/documents',
  serviceOrderReturnsDetailChecklists: '/warehouses/service-order-returns/:id/checklists',
  fastTrackIssues: '/warehouses/fast-track-issues',
  fastTrackIssuesCreate: '/warehouses/fast-track-issues/create',
  fastTrackIssuesDetailRowControl: '/warehouses/fast-track-issues/:id/:section*',
  fastTrackIssuesDetailOverview: '/warehouses/fast-track-issues/:id/overview',
  fastTrackIssuesDetailDocuments: '/warehouses/fast-track-issues/:id/documents',
  fastTrackIssuesDetailIssueNotes: '/warehouses/fast-track-issues/:id/issue-notes',
  costCorrections: '/warehouses/cost-corrections',
  costCorrectionDetailRowControl: '/warehouses/cost-correction/:id/:section*',
  costCorrectionDetailOverview: '/warehouses/cost-correction/:id/overview',
  costCorrectionDetailDocuments: '/warehouses/cost-correction/:id/documents',
  transfers: '/warehouses/transfers',
  transferOrderCreate: '/warehouses/transfer-order/create',
  transferOrderDraft:
    '/warehouses/transfer-order-draft/transfer-order-variant/:transferOrderVariantId',
  transferOrderDetailRowControl: '/warehouses/transfer-order/:id/:section*',
  transferOrderDetailOverview: '/warehouses/transfer-order/:id/overview',
  transferOrderDetailIssueNotes: '/warehouses/transfer-order/:id/issue-notes',
  transferOrderDetailDocuments: '/warehouses/transfer-order/:id/documents',
  issueNoteCorrections: '/warehouses/issue-note-corrections',
  issueNoteCorrectionDetailRowControl: '/warehouses/issue-note-corrections/:id/:section*',
  issueNoteCorrectionDetailOverview: '/warehouses/issue-note-corrections/:id/overview',
  issueNoteCorrectionDetailDocuments: '/warehouses/issue-note-corrections/:id/documents',
  deliveryNoteList: '/warehouses/delivery-note-list',
  deliveryNoteDetailRowControl: '/warehouses/delivery-note/:id/:section*',
  deliveryNoteDetailOverview: '/warehouses/delivery-note/:id/overview',
  deliveryNoteDocumentPreview: '/warehouses/delivery-note/document-preview/:id',
  receiveNoteList: '/warehouses/receive-note-list',
  receiveNoteCreate: '/warehouses/receive-note-create',
  receiveNoteDetailRowControl: '/warehouses/receive-note-detail/:id/:section*',
  receiveNoteDetailOverview: '/warehouses/receive-note-detail/:id/overview',
  receiveNoteDetailDocuments: '/warehouses/receive-note-detail/:id/documents',
  receiveNoteDetailChecklists: '/warehouses/receive-note-detail/:id/checklists',
  receiveNoteCorrectionCreate:
    '/warehouses/receive-note-detail/:receiveNoteCreateId/receive-note-correction-create',
  receiveNoteCorrectionDetailRowControl: '/warehouses/receive-note-correction-detail/:id/:section*',
  receiveNoteCorrectionDetailOverview: '/warehouses/receive-note-correction-detail/:id/overview',
  receiveNoteCorrectionDetailDocuments: '/warehouses/receive-note-correction-detail/:id/documents',
  receiveNoteCorrectionDetailChecklists:
    '/warehouses/receive-note-correction-detail/:id/checklists',
  receiveNoteCorrectionsList: '/warehouses/receive-note-corrections-list',
  priceList: '/warehouses/price-list',
  updateJobsList: '/warehouses/update-jobs-list',
  updateJobCreate: '/warehouses/update-job/create',
  updateJobDetailRowControl: '/warehouses/update-job-detail/:id/:section*',
  updateJobDetailOverview: '/warehouses/update-job-detail/:id/overview',
  updateJobDetailUpdateList: '/warehouses/update-job-detail/:id/update-list',
  updateJobDetailUpdateResults: '/warehouses/update-job-detail/:id/update-results',
  directSalesList: '/warehouses/direct-sales',
  directSalesCreate: '/warehouses/direct-sales/create',
  directSalesVariantChange: '/warehouses/direct-sales/:id/variant/:directSaleVariantId/change',
  directSalesDetailRowControl: '/warehouses/direct-sales/:id/:section*',
  directSalesDetailOverview: '/warehouses/direct-sales/:id/overview',
  directSalesDetailDocuments: '/warehouses/direct-sales/:id/documents',
  directSalesDetailVehicle: '/warehouses/direct-sales/:id/vehicle',
  directSalesDetailCustomer: '/warehouses/direct-sales/:id/customer',
  directSalesDetailChecklists: '/warehouses/direct-sales/:id/checklists',
  directSalesDetailTasks: '/warehouses/direct-sales/:id/tasks',
  supplierOrders: '/warehouses/supplier-orders',
  purchaseList: '/warehouses/purchase-list',
  supplierOrderList: '/warehouses/supplier-order-list',
  supplierOrderDetailRowControl: '/warehouses/supplier-order/:id/:section*',
  supplierOrderDetailOverview: '/warehouses/supplier-order/:id/overview',
  supplierOrderDetailDocuments: '/warehouses/supplier-order/:id/documents',
  reporting: '/warehouses/reporting',
  reportingTab: '/warehouses/reporting/:id',
  reportingHyundaiMobisIris: '/warehouses/reporting/hyundai-mobis-iris',
} as const;

export const tiresInventoryRoutes = {
  overview: '/tires-inventory',
  tireOrders: '/tires-inventory/tire-orders',
  tireSets: '/tires-inventory/tire-sets',
  tireSetRequests: '/tires-inventory/tire-set-requests',
  tireList: '/tires-inventory/tire-list',
  tireTransportDocuments: '/tires-inventory/tire-transport-documents',
  storageLocationCapacity: '/tires-inventory/storage-location-capacity',
  createTireOrder: '/tires-inventory/tire-order/create',
  tireOrderDetail: '/tires-inventory/tire-order/:id',
} as const;

export const taskManagerRoutes = {
  taskOverview: '/task-manager',
  taskCalendar: '/task-manager/calendar',
} as const;

export const restrictedAreaRoutes = {
  home: '/restrictedArea',
} as const;

export const redirectRoute = '/redirect';

export const iamRedirectRoute = '/iam-redirect';
export const workspaceRedirectRoute = '/workspace-iam-redirect';
export const workspaceInitializeRoute = '/workspace-initialize';
export const resetPasswordRoute = '/reset-password';
export const userInvitationRoute = '/user-invitation';

export const microsoftOAuthRedirect = '/microsoft-oauth';
export const microsoftOAuthFinish = '/microsoft-oauth-finish';
export const userMailboxOAuthFinish = '/user-mailbox-oauth-finish';

export const doc360Routes = {
  redirect: '/doc360-redirect',
  workspaceSelection: '/doc360-workspace',
  initialize: '/doc360-initialize',
};

export const notFoundRoute = '/not-found';

export const sharePresetRoute = '/share-preset/:code/:sharedPresetId';

export const importRoutes = {
  overview: '/import',
  extractedDeliveryNotes: '/import/extracted-delivery-notes',
  detail: '/import/:id',
} as const;
